export default {"src":"/_next/static/media/b_corp_white.46d01884.svg","height":72,"width":73,"blurWidth":0,"blurHeight":0};